var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full border-t border-b border-gray-300 bg-gray-100 py-4"},[_c('div',{staticClass:"w-full px-6 xxl:px-0 xxl:w-3/5 m-auto flex items-center"},[_c('router-link',{staticClass:"ml-1 sub-header-link mr-8",attrs:{"to":{
        name: 'dashboard'
      },"tag":"a"}},[_vm._v("Dashboard")]),_c('router-link',{staticClass:"ml-1 sub-header-link mr-8",attrs:{"to":{
        name: 'broker-home'
      },"tag":"a"}},[_vm._v("Brokers")]),_c('router-link',{staticClass:"ml-1 sub-header-link mr-8",attrs:{"to":{
        name: 'planner-home'
      },"tag":"a"}},[_vm._v("Planners")]),_c('router-link',{staticClass:"ml-1 sub-header-link mr-8",attrs:{"to":{
        name: 'broker-metric-home'
      },"tag":"a"}},[_vm._v("Metrics (BP)")]),_c('router-link',{staticClass:"ml-1 sub-header-link mr-8",attrs:{"to":{
        name: 'feedback-list'
      },"tag":"a"}},[_vm._v("Feedback (BP)")]),_c('a',{staticClass:"sub-header-link",attrs:{"href":"#"},on:{"click":function($event){return _vm.logout()}}},[_vm._v("Logout")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }